// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getRgaSearchResult} from '../state';

const setRgaAdditionalDataFlag = (state, action) => action.dataTypeFlag;

export default (state = getRgaSearchResult().additionalDataFlag, action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_ADDITIONAL_DATA_INFO_FLAG]: setRgaAdditionalDataFlag
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/additional-data-flag.js